import { projectCreationError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ zone, project, configuration, portfolios, planzone }) =>
    present(
      repository
        .saveProject(zone, project, configuration)
        .then((project) => {
          portfolios.forEach((portfolio) => {
            repository.saveProjectInPortfolio(planzone, portfolio, project);
          });
          return repository
            .updateProjectConfiguration(project, configuration)
            .then(() => ({
              zone,
              project,
              configuration,
              portfolios,
              planzone,
            }));
        })
        .catch((e) =>
          Promise.reject({
            error: { ...projectCreationError, ...e },
            zone,
            project,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
